import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlGenMahalleCaddeSokakAramaComponent } from './ctl-gen-mahalle-cadde-sokak-arama/ctl-gen-mahalle-cadde-sokak-arama.component';
import {GenMahalleCaddeSokakService} from './ctl-gen-mahalle-cadde-sokak.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
import { ControlConditionModel } from '../../../models/gen-control.model';
import { DkGlobalUserSettingsService } from '../../../services/dk-global-user-settings.service';

@Component({
  selector: 'dk-ctl-gen-mahalle-cadde-sokak',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlGenMahalleCaddeSokakAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [GenMahalleCaddeSokakService],
  templateUrl: './ctl-gen-mahalle-cadde-sokak.component.html',
  styleUrls: ['./ctl-gen-mahalle-cadde-sokak.component.scss'],
})
export class CtlGenMahalleCaddeSokakComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = this.globalSettings.globalLabelMode;
  public crudPopupVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "GenMahalleCaddeSokak";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public data: any;
  @Input() code: any;
  @Input() labelWidth: string;
  @Input() validationRulesMap:any[] = [];
  @Input() validationV2= false;
  @Input() controlCondition: ControlConditionModel[];
  @Input() warningMessage: string | null = null;
  @Input() tabIndex:number;
  //@Input() belediyeCode: any;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  private lastRequestId = 0;

  constructor(private service: GenMahalleCaddeSokakService, private utilsService: UtilsService, private ortakService: OrtakService,
    private globalSettings:DkGlobalUserSettingsService
  ) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
        this.service.setParams(this.isReadOnly,this.isBindCheck)
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.isReadOnly,this.isBindCheck)
      }
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }



  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {

    const requestId = ++this.lastRequestId;
    this.data = this.service.getData(Number(code),this.control,this.control.dlistMetadata.baseEntity,isSetData,this.controlCondition);
    this.data.load().done((result: any) => {
      if (requestId !== this.lastRequestId){
        return;
      } 
      if (result.length > 0) {
        this.title = result[0].GenMahalleKoy.Ad + ', ' + result[0].GenCaddeSokak.Ad;
        this.code = result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }

    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

